<template>
  <el-card class="list">
    <div slot="header">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{ name: 'followees' }">
          Auto followees
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form :inline="true" :model="form" :rules="formRules" ref="form">
      <el-form-item label="User" prop="user_id">
        <el-select
          v-model="form.user_id"
          filterable
          remote
          :remote-method="findUsers"
          placeholder="Search by email"
          :loading="loading"
          clearable
        >
          <el-option
            v-for="user in findings"
            :key="user.id"
            :value="user.id"
            :label="`${user.user_name} (${user.email})`"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="userAddToFollowees">
          <i class="fa fa-plus"></i>
          Add
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="followees" style="width: 100%" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70"></el-table-column>
      <el-table-column prop="user_name" label="USERNAME" sortable></el-table-column>
      <el-table-column prop="email" label="EMAIL" sortable></el-table-column>
      <el-table-column prop="status" label="STATUS" sortable></el-table-column>
      <el-table-column
        prop="registration_time"
        label="REGISTRATION"
        sortable
        :formatter="dateFormatter"
      ></el-table-column>
      <el-table-column width="84" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click.prevent="userDetails(scope.row.id)">
            <i class="fa fa-address-card-o" aria-hidden="true"></i>
          </el-button>
          <el-button type="text" @click.prevent="userRemoveFromFollowees(scope.row.id)">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import compact from 'lodash/compact'

export default {
  data () {
    return {
      form: { user_id: null },
      formRules: {
        user_id: [{ required: true, message: 'Please select User', trigger: 'change' }]
      },
      findings: []
    }
  },

  computed: {
    ...mapState('users', ['entities', 'loading']),
    ...mapGetters('users', { users: 'all' }),
    ...mapState('autofollowees', { follweeIds: 'ids' }),
    followees () {
      return compact(this.follweeIds.map(id => this.entities[id]))
    }
  },

  methods: {
    userDetails (id) {
      this.select(id)
      this.$router.push({ name: 'user', params: { id } })
    },

    async userRemoveFromFollowees (id) {
      await this.updateFollowees(this.follweeIds.filter(fid => fid !== id))
      this.$message({
        type: 'success',
        message: `User successfully removed from the list`
      })
    },

    userAddToFollowees () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await this.updateFollowees([...this.follweeIds, this.form.user_id])
          this.$refs['form'].resetFields()
          this.$message({
            type: 'success',
            message: `User successfully added to the list`
          })
        }
      })
    },

    ...mapActions('users', {
      fetchAll: 'fetchAll',
      select: 'select'
    }),

    ...mapActions('autofollowees', ['fetchFollowees', 'updateFollowees']),

    dateFormatter (row, col) {
      return moment(row.registration_time).format('ll')
    },

    findUsers (name) {
      if (name.length > 1) {
        // min 2 chars
        this.findings = this.users.filter(user => {
          return user.email.toLowerCase().indexOf(name.toLowerCase()) > -1
        })
      } else {
        this.findings = []
      }
    }
  },

  created () {
    if (!this.$store.state.users.loaded) {
      this.fetchAll()
    }
    this.fetchFollowees()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/Followees.vue